module.exports = "<p>\r\n  pages works!\r\n</p>\r\n"